import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import { common } from '@mui/material/colors';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SyncIcon from '@mui/icons-material/Sync';
import BrandLogo from 'common/components/brand-logo';
import React, { useEffect } from 'react';
import ModalShareSurvey from 'pages/admin/survey/components/modal-share-survey';
import { setViewMode } from 'slices/viewModeSlice';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';
import { closeSurvey } from 'utils/preview_helpers';

interface SidebarProps {
    surveyStep?: number;
    setSurveyStep?: () => void;
}
const Sidebar: React.FC<SidebarProps> = ({ surveyStep, setSurveyStep }) => {
    const viewMode = useAppSelector(
        (state: RootState) => state.viewMode.viewMode
    );
    const dispatch = useAppDispatch();
    const [selectedIndex, setSelectedIndex] = React.useState(2);
    const me = useAppSelector((state) => state.previewSurvey.me);
    const surveyState = useAppSelector(
        (state) => state.previewSurvey.surveyState
    );

    const sendMessageToParent = (newMode: 'tablet' | 'mobile' | 'pc') => {
        window.parent.postMessage(
            { type: 'CHANGE_MODE', payload: { mode: newMode } },
            window.location.origin
        );
    };

    useEffect(() => {
        setSelectedIndex(
            viewMode === 'pc'
                ? 0
                : viewMode === 'tablet'
                  ? 1
                  : viewMode === 'mobile'
                    ? 2
                    : 0
        );
    }, [viewMode]);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
        viewMode: 'tablet' | 'mobile' | 'pc'
    ) => {
        setOpenSidebar(false);
        setTimeout(() => {
            dispatch(setViewMode(viewMode));
            sendMessageToParent(viewMode);
            setSelectedIndex(index);
        }, 300);
    };
    const [openSidebar, setOpenSidebar] = React.useState<boolean>(false);
    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };
    const [openModalShareSurvey, setOpenModalShareSurvey] =
        React.useState(false);
    return (
        <>
            <IconButton
                onClick={toggleSidebar}
                sx={{
                    position: 'fixed',
                    top: 90,
                    right: openSidebar ? '88%' : 24,
                    transform: 'translateY(-50%)',
                    zIndex: 1,
                    transition: 'right 0.3s ease',
                    color: common.white,
                    borderRadius: 'unset',
                    padding: 0,
                    width: '3rem',
                    height: '3rem',
                    display: ['block', 'none'],
                    backgroundColor: (theme) =>
                        openSidebar ? theme.palette.primary.main : 'unset',
                    '&:hover': {
                        backgroundColor: (theme) =>
                            openSidebar ? theme.palette.primary.main : 'unset',
                    },
                }}
            >
                {openSidebar ? (
                    <MenuIcon
                        sx={{
                            fontSize: '3rem',
                            display: 'block',
                            margin: 'auto',
                        }}
                    />
                ) : (
                    <MenuIcon
                        sx={{
                            fontSize: '3rem',
                            display: 'block',
                            margin: 'auto',
                        }}
                    />
                )}
            </IconButton>

            <Drawer
                anchor="right"
                open={openSidebar}
                onClose={toggleSidebar}
                variant="persistent"
                sx={{
                    '& .MuiDrawer-paper': {
                        width: '88%',
                        height: '100%',
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        boxSizing: 'border-box',
                        zIndex: 2,
                        backgroundColor: common.white,
                    },
                }}
            >
                <Box>
                    <Box p={3}>
                        <BrandLogo width={100} />
                    </Box>
                    {surveyStep === 1 && (
                        <>
                            <List component="nav">
                                <ListItemButton
                                    onClick={() => {
                                        setOpenSidebar(false);
                                        setSurveyStep && setSurveyStep();
                                    }}
                                >
                                    <ListItemIcon>
                                        <SyncIcon
                                            sx={{
                                                color: (theme) =>
                                                    theme.palette.primary.main,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Bắt đầu lại khảo sát" />
                                </ListItemButton>
                            </List>
                            <Divider />
                        </>
                    )}

                    <Accordion
                        defaultExpanded
                        disableGutters
                        sx={{
                            boxShadow: 'none',
                            border: 'none',
                            padding: 0,

                            '&::before': {
                                display: 'none',
                            },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                            sx={{
                                padding: 0,
                                display: 'flex',
                                fontWeight: '500',
                                justifyContent: 'space-around',
                                '& .MuiAccordionSummary-content': {
                                    margin: 0,
                                    flexGrow: 0,
                                },
                            }}
                        >
                            Xem trên thiết bị
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                padding: 0,
                            }}
                        >
                            <List component="nav">
                                <ListItemButton
                                    selected={selectedIndex === 0}
                                    onClick={(event) =>
                                        handleListItemClick(event, 0, 'pc')
                                    }
                                >
                                    <ListItemIcon>
                                        <InboxIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Website" />
                                </ListItemButton>
                                <ListItemButton
                                    selected={selectedIndex === 1}
                                    onClick={(event) =>
                                        handleListItemClick(event, 1, 'tablet')
                                    }
                                >
                                    <ListItemIcon>
                                        <DraftsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Máy tính bảng" />
                                </ListItemButton>
                                <ListItemButton
                                    selected={selectedIndex === 2}
                                    onClick={(event) =>
                                        handleListItemClick(event, 2, 'mobile')
                                    }
                                >
                                    <ListItemIcon>
                                        <InboxIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Điện thoại" />
                                </ListItemButton>
                            </List>
                        </AccordionDetails>
                    </Accordion>
                    <Divider />
                    <List
                        component="nav"
                        sx={{
                            color: (theme) => theme.palette.primary.main,
                            '& .MuiTypography-root': {
                                fontWeight: '700',
                            },
                        }}
                    >
                        {surveyState.answerable && (
                            <ListItemButton
                                onClick={() => setOpenModalShareSurvey(true)}
                            >
                                <ListItemIcon>
                                    <ShareOutlinedIcon
                                        sx={{
                                            color: (theme) =>
                                                theme.palette.primary.main,
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText primary="Chia sẻ" />
                            </ListItemButton>
                        )}
                        {me.creator && (
                            <ListItemButton
                                onClick={() =>
                                    closeSurvey(Number(surveyState.id), me)
                                }
                            >
                                <ListItemIcon>
                                    <CloseOutlinedIcon
                                        sx={{
                                            color: (theme) =>
                                                theme.palette.primary.main,
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText primary="Đóng" />
                            </ListItemButton>
                        )}
                    </List>
                </Box>
            </Drawer>
            {openModalShareSurvey && (
                <ModalShareSurvey
                    open={openModalShareSurvey}
                    onClose={() => setOpenModalShareSurvey(false)}
                />
            )}
        </>
    );
};

export default Sidebar;
